$(document).on('click', '.js-print-basket' ,function(){
    let button = $(this);
    let button_html = button.html();
    button.html('<img class="loader" src="'+LOADER+'" alt="ajax loader">');
    $('head').append('<link rel="stylesheet" href="'+ THEME_DIR +'/assets/css/print/cart_print.css?ver=6" media="print">');
    setTimeout(function() {
        window.print();
        button.html(button_html);
    }, 1000);
})

$(document).on('click', '.js-basket-to-xls' ,function(){
    $.ajax({
        type:    'POST',
        url:      BASE_URL+'/wp-admin/admin-ajax.php',
        data: {
            'action': 'export_cart_to_xls',
        },
        dataType: 'html',
        success:  function(response) {
            let link = document.createElement("a");
            link.download = window.location.hostname + "-cart-export.xlsx";
            link.href = "../wp-content/themes/pixelshop_child/exports/"+ response;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        },
        complete: function() {
            $.ajax({
                type: 'POST',
                url: BASE_URL + '/wp-admin/admin-ajax.php',
                data: {
                    'action': 'delete_cart_xls_exports',
                },
            })
        }
    });
});

$(document).on('click', '.js-empty-basket' ,function(e){
    if(confirm($(this).data('confirm-text'))){

        $(this).html('<img class="loader" src="'+LOADER+'" alt="ajax loader">')

        $.ajax({
            type: 'POST',
            url: BASE_URL + '/wp-admin/admin-ajax.php',
            data: {
                'action': 'empty_basket',
            },
            success: function(){
                location.reload();
            }
        })
    }
})

/* ajax remove product from cart */
$(document).on('click', '.js-remove-product-from-cart' ,function(e){
    e.preventDefault();
    let remove_button = $(this);
    remove_button.html('<img class="loader" src="' + LOADER + '" alt="ajax loader">')
    remove_button.css('border', 'none');
    remove_button.css('background', 'none');
    let is_mini_cart = remove_button.data('mini-cart');
    let cart_item_key = remove_button.data('cart-key');

    // remove_item_from_cart
    jQuery.post(BASE_URL+'/wp-admin/admin-ajax.php',
    {
        action: 'remove_item_from_cart',
        cart_item_key: cart_item_key,
        is_mini_cart: is_mini_cart,
        remove_link: remove_button.attr( 'href' )
    },
    function(response) {

        response = JSON.parse(response);

        if(is_mini_cart){
            update_mini_cart_count(response['header_html']);
            update_mini_cart_content(true, response['header_html']);
            /* if no items in mini-cart, hide overlay */
            let count_in_cart = $('.js-cart-count-badge').first().html().trim();
            if(count_in_cart == 0){
                hide_overlay();
            }
        }else{
            //update_cart_div( response['cart_content'] );
            $('.woocommerce').replaceWith(response['cart_content']);
        }

        if(response['success']){
            notif('warning', response['notif']);

            // vyvolá funkciu ak existuje
            if (typeof on_remove_from_cart == 'function') {
                on_remove_from_cart(remove_button);
            }

        }else{
            notif('danger', response['notif']);
        }
    });
})

$(document).on('click', '.js-cart-remove-coupon' , function (e){
    e.preventDefault();
    let remove_button = $(this);
    /* nefungovalo ak mal kupón v názve # */
    let coupon_code = remove_button.data( 'coupon' );
    let url = remove_button.data( 'url' );
    coupon_code = encodeURIComponent(coupon_code);
    url = url + coupon_code;
    let data = {
        security: remove_button.data( 'nonce' ),
        coupon: coupon_code
    };

    $.ajax({
        type:    'POST',
        url:      url,
        data:     data,
        dataType: 'html',
        success:  function(response) {
            notif('warning', remove_button.data('success-text'));
            update_cart_div( response );
        },
        complete: function() {}
    });
});


$(document).on('click', '#apply_coupon_cart' , function (e){
    e.preventDefault();

    let button = $(this);

    if(!$('#coupon_code').val()){
        notif('danger', button.data('empty_text'));
        return;
    }

    let form = $('form.woocommerce-cart-form');

    $( '<input />' ).attr( 'type', 'hidden' ).attr( 'name', 'apply_coupon' ).attr( 'value', 'Apply Coupon' ).appendTo( form );

    $.ajax( {
        type:     form.attr( 'method' ),
        url:      form.attr( 'action' ),
        data:     form.serialize(),
        dataType: 'html',
        success:  function( response ) {

            update_cart_div( response );

            if(!$('.woocommerce-message').length){
                if($('#coupon_invalid').length){
                    notif('danger', $('#coupon_invalid').val());
                }else{
                    notif('success', button.data('success_text'));
                }
            }
        }
    } );

})

$( document ).on('change input paste keyup', '.cart-table .product-quantity input', function(){
    $('#update_cart').click();
})

var updateCartInverval;
$(document).on('click', '#update_cart' , function (e){
    e.preventDefault();
    $(this).html('<img class="loader" width="20" src="'+LOADER+'" alt="ajax loader">');
    clearTimeout(updateCartInverval);
    updateCartInverval = setTimeout(updateCart, 1000);
})

function updateCart(){

    let error = false;
    $('.woocommerce-cart-form .product-quantity .quantity input').each(function(){

        let item = $(this);
        let max = parseInt(item.attr('max'));
        let val = parseInt(item.val());

        if(max < val){
            item.css('border-color', 'red');
            error = true;
            notif('danger', item.parents('.product-quantity').data('error-text'));
        }
    })
    if(error){
        return;
    }

    let form = $('.woocommerce-cart-form');

    $( '<input />' ).attr( 'type', 'hidden' )
        .attr( 'name', 'update_cart' )
        .attr( 'value', 'Update Cart' )
        .appendTo( form );

    $.ajax( {
        type:     form.attr( 'method' ),
        url:      form.attr( 'action' ),
        data:     form.serialize(),
        dataType: 'html',
        success:  function( response ) {
            update_cart_div( response );
            notif('success', form.data('success_text'));
        }
    });
}

function update_cart_div(response){
    $('.woocommerce').replaceWith($('.woocommerce', response));

    if($('.js-cart-upsale', response).length){
        /* update cross sell products images */
        lazyLoadInstance.update();
    }
}

$(document).on('keypress', '.woocommerce-cart-form', function(e) {
    let keyCode = e.keyCode || e.which;
    if (keyCode === 13) {
        if( $('#coupon_code').is(':focus')){
            $('#apply_coupon_cart').click();
        }
        e.preventDefault();
        return false;
    }
});
